import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import BlogSidebar from '../../components/BlogSidebar'
import { useFetch } from '../../hooks/useFetch';
import { fetchBlogs } from '../../api/api';
import { useTranslation } from 'react-i18next';

const BlogSingle = ({ isLoading, error, BlogDetails }) => {
    const { data } = useFetch(['blogs'], fetchBlogs);
    const [categories, setCategories] = useState([]);
    const [tags, setTags] = useState([]);
    const [blogTags, setBlogTags] = useState([]);
    const { t } = useTranslation();
    useEffect(() => {
        if (!data) return;
        const extractUniqueValues = (key) => {
            return Array.from(new Set(data?.data?.data.flatMap((course) => course.data[key])));
        };

        setCategories(extractUniqueValues("categories"));
        setTags(extractUniqueValues("tags"));
    }, [data]);

    useEffect(() => {
        if (BlogDetails?.data?.data?.tags) {
            setBlogTags(BlogDetails?.data?.data?.tags);
        }
    }, [BlogDetails]);

    return isLoading ? <>loading</> : error ? <>error</> : (
        <section className="wpo-blog-single-section section-padding">
            <div className="container">
                <div className="row">
                    <div className={`col col-lg-8 col-12`}>
                        <div className="wpo-blog-content">
                            <div className="post format-standard-image">
                                <div className="entry-media">
                                    <img
                                        src={`${process.env.REACT_APP_API_URL}/api/images/${BlogDetails?.data?.data?.thumbnail}`}
                                        alt={t('blogContent.thumbnailAlt')}
                                    />
                                </div>
                                <div className="entry-meta">
                                    <ul>
                                        <li>
                                            <i className="fi flaticon-user"></i> {t('blogContent.by')}{' '}
                                            <Link to="/blog-single/1">{BlogDetails?.data?.data?.author}</Link>
                                        </li>
                                        <li>
                                            <i className="fi flaticon-calendar"></i>{' '}
                                            {BlogDetails?.data?.publishedAt.slice(0, 10)}
                                        </li>
                                    </ul>
                                </div>
                                <h2>{BlogDetails?.data?.data?.title}</h2>
                                <p>{BlogDetails?.data?.data?.description}</p>
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: BlogDetails?.data?.data?.content,
                                    }}
                                ></div>
                            </div>

                            <div className="tag-share clearfix">
                                <div className="tag">
                                    <span>{t('blogContent.tags')}:</span>
                                    <ul>
                                        {blogTags.map((tag, titem) => (
                                            <li key={titem}>
                                                <Link to="/blog-single/1">{tag}</Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>

                            <div className="author-box">
                                <div className="author-content">
                                    <Link to="/blog-single/1" className="author-name">
                                        {t('blogContent.author')} {BlogDetails?.data?.data?.author}
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <BlogSidebar categories={categories} tags={tags} />
                </div>
            </div>
        </section>
    )

}

export default BlogSingle;
